import './ChapterPuzzlePiece.scss';
import Component from './ChapterPuzzlePiece';
export default Component;